


































import { Component } from "vue-property-decorator";
import OneDayAddV5Covit from "./OneDayAddV5Covit.vue";

@Component
export default class OneDayAddV6 extends OneDayAddV5Covit {
  //物価対応料
  protected disableCheckLivingCostFlg(): boolean {
    let result = false;
    if (
      this.officeHistory.medical_living_cost == 1 ||
      this.officeHistory.business_div == 3 ||
      this.baseDisableCheck()
    ) {
      result = true;
    }
    return result;
  }

  //登録時に、disabledの項目は0にする
  public clearDisableItemV6() {
    this.clearDisableItemV4();
    //物価対応料
    if (this.disableCheckLivingCostFlg()) {
      this.receiptVisitRecord.living_cost_flg = 0;
    }
  }
}
